import React, { Component } from "react";
import { BreadCumb, NewDocTable, NavBar, TimeOut } from "../../components";
import config from "../../config";
import moment from "moment";
import { ApiClient } from "../../libs/apiClient";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { connect } from "react-redux";
const apiClient = ApiClient.getInstance();
const today = moment(new Date()).format("YYYYMMDD");

const headers = [
    { title: "Recurso", value: true, field: "ResCode" },
    { title: "Descripción", value: true, field: "ResName" },
    { title: "Tipo", value: true, field: "ResType" },
    { title: "Grupo", value: true, field: "ResGrpNam" },
    { title: "Código de barras", value: true, field: "CodeBars" }
];

class RscMasterData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateData: false,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
        };
    }

    async componentDidMount() {
        const date = {
            dateInit: today,
            dateFinal: today,
        };
        await this.searchDocuments(date);
    }

    searchDocuments = async (newDate) => {
        const { enableSpinner} = this.props;
        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1: newDate.docStatus || "---",
            table: "ORSC",
            docNumSearch: newDate.docNumSearch || "--",
        };

        enableSpinner(true);
        const response = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({ data: response.data });
        }
    }

    render() {
        const { data, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={"DATOS MAESTROS DEL RECURSO"} url1={"#"} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <span id="linkOrdProv" className="h2 text-muted"> DATOS MAESTROS DEL RECURSO </span>
                    <NewDocTable
                        headers={headers}
                        view={"rscMasterData"}
                        data={data}
                        search={this.searchDocuments} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = (dispatch) => {
    return {enableSpinner: (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })};
};

export default connect(mapStateToProps, mapDispatchToProps) (RscMasterData);